export default __webpack_public_path__ + "static/media/upload-bad-example.5b0b756b.png";